<template>
  <form>
    <string-form-field
      :label="$t('status.fields.label')"
      required
      multiline
      :value="value.label"
      :disabled="disabled"
      :error="findError('label')"
      @input="propertyChange('label', $event)"
    />

    <number-form-field
      :label="$t('status.fields.maxDays')"
      :required="value.type === 'INTERMEDIATE'"
      :precision="0"
      :value="value.maxDays"
      :disabled="disabled"
      :error="findError('maxDays')"
      @input="propertyChange('maxDays', $event)"
    />

    <boolean-form-field
      v-if="!disabled && !['SUCCESS', 'FAILURE'].includes(value.type)"
      :label="$t('status.fields.failable')"
      :value="failable"
      @input="makeFailable($event)"
    />

    <user-type-form-field
      :label="$t('status.fields.primaryActor')"
      required
      multiple
      :dropdown="false"
      :value="value.primaryActor"
      :disabled="disabled"
      :error="findError('primaryActor')"
      @input="propertyChange('primaryActor', $event)"
    />

    <string-form-field
      :label="$t('status.fields.helpText')"
      :value="value.helpText"
      :disabled="disabled"
      multiline
      :error="findError('helpText')"
      @input="propertyChange('helpText', $event)"
    />

    <b-button
      v-if="
        !isSideStatus(value) && !['INITIAL', 'FAILURE'].includes(value.type)
      "
      block
      variant="warning"
      @click.prevent="$emit('manage-tags')"
    >
      {{ $t("status.actions.manageTags") }}
    </b-button>

    <div class="d-flex">
      <b-button
        class="flex-grow-1"
        v-if="
          !disabled &&
            !isSideStatus(value) &&
            !['INITIAL', 'FAILURE'].includes(value.type)
        "
        variant="success"
        @click.prevent="$emit('add-status-before')"
      >
        {{ $t("status.actions.addStatusBefore") }}
      </b-button>

      <b-button
        class="flex-grow-1"
        v-if="
          !disabled &&
            !isSideStatus(value) &&
            !['SUCCESS', 'FAILURE'].includes(value.type)
        "
        variant="success"
        @click.prevent="$emit('add-status-after')"
      >
        {{ $t("status.actions.addStatusAfter") }}
      </b-button>

      <b-button
        class="flex-grow-1"
        v-if="
          !disabled &&
            !isSideStatus(value) &&
            !['INITIAL', 'SUCCESS', 'FAILURE'].includes(value.type)
        "
        :disabled="hasSideStatus"
        variant="success"
        @click.prevent="$emit('add-side-status')"
      >
        {{ $t("status.actions.addSideStatus") }}
      </b-button>
    </div>

    <b-button
      v-if="
        !disabled && !['INITIAL', 'SUCCESS', 'FAILURE'].includes(value.type)
      "
      :disabled="!value.deletable"
      block
      variant="remove"
      @click.prevent="$emit('remove')"
    >
      {{ $t("common.remove") }}
    </b-button>
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import UserTypeFormField from "@/modules/user/protected/UserTypeFormField";

export default {
  mixins: [EditorMixin],

  components: {
    UserTypeFormField
  },

  props: {
    failureStatusId: {
      type: String,
      required: true
    },

    hasSideStatus: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    failable() {
      return !!this.value.outgoingArrows.find(
        a => a.toStatusId === this.failureStatusId
      );
    }
  },

  methods: {
    isSideStatus(s) {
      return s.colPosition === 2;
    },

    makeFailable(failable) {
      const outgoingArrows = failable
        ? [
            // Aggiunge arco
            ...this.value.outgoingArrows,
            {
              label: "Annulla",
              fromStatusId: this.value.id,
              toStatusId: this.failureStatusId
            }
          ]
        : // Rimuove arco
          this.value.outgoingArrows.filter(
            a => a.toStatusId !== this.failureStatusId
          );
      this.propertyChange("outgoingArrows", outgoingArrows);
    }
  }
};
</script>
